function meter(num, unit) {
  if (!num) return ''
  if (typeof (num) !== 'number') return ''
  if (unit == 'km') return Math.round(num / 100) / 10 + ' km'
  return Math.round(num * 0.00621371) / 10 + ' mi.'
}

export default meter